export default __webpack_public_path__ + "static/media/AGP.1041bffa.jpeg";